import { cn } from "@/utils/helpers";
import { ReactNode } from "react";

type CenteredAreaProps = {
  className?: string;
  children: ReactNode;
};

export default function CenteredArea({ className, children }: CenteredAreaProps) {
  return (
    <div className={cn("flex h-full min-h-40 flex-grow items-center justify-center rounded-xl", className)}>
      {children}
    </div>
  );
}
